// components/BottomNav.jsx
import { Navbar, NavbarItem, Link } from "@nextui-org/react";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaExchangeAlt, FaChartLine, FaRocket, FaGift, FaHdd ,FaShareAlt} from "react-icons/fa";

export default function BottomNav() {
  const location = useLocation();
  const [activePath, setActivePath] = useState("/");

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location]);
  return (
    <Navbar
      maxWidth="full"
      className="fixed w-full shadow-lg z-50 bottom-0 !top-auto"
    >
      <div className="flex justify-around w-full">
        <NavbarItem>
          <Link
            href="/"
            className={`flex flex-col items-center ${activePath=== "/" ? "text-gray-300" : "text-gray-500"}  hover:text-gray-300 `}
          >
            <FaExchangeAlt className="h-6 w-6" />
            <span className="text-xs mt-1">交易</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link
            href="/liquidity"
            className={`flex flex-col items-center ${activePath=== "/liquidity" ? "text-gray-300" : "text-gray-500"}  hover:text-gray-300 `}
          >
            <FaChartLine className="h-6 w-6" />
            <span className="text-xs mt-1">流动性</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link
            href="/launchpad"
            className={`flex flex-col items-center ${activePath=== "/launchpad" ? "text-gray-300" : "text-gray-500"}  hover:text-gray-300 `}
          >
            <FaGift className="h-6 w-6" />
            <span className="text-xs mt-1">生态专区</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link
            href="/mining"
            className={`flex flex-col items-center ${activePath=== "/mining" ? "text-gray-300" : "text-gray-500"}  hover:text-gray-300 `}
          >
            <FaHdd className="h-6 w-6" />
            <span className="text-xs mt-1">矿机</span>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link
            href="/profile"
            className={`flex flex-col items-center ${activePath=== "/profile" ? "text-gray-300" : "text-gray-500"}  hover:text-gray-300 `}
          >
            <FaShareAlt className="h-6 w-6" />
            <span className="text-xs mt-1">分享</span>
          </Link>
        </NavbarItem>
      </div>
    </Navbar>
  );
}